import color from './color';

export const colorScheme = {
  default: 'pastel1',
  pastel: [color.red4, color.orange5, color.blue6, color.green5],
  purples: [
    color.purple6,
    color.purple5,
    color.purple4,
    color.purple3,
    color.purple2,
    color.purple1,
  ],
  broad: [color.red5, color.green2, color.orange6],
  rangeValue: [color.orange2, color.grey3],
};

const theme = {
  background: '#ffffff',
  textColor: color.black1,
  fontFamily: 'Khula',
  fontSize: 12,
  axis: {
    domain: {
      line: {
        strokeWidth: 0,
      },
    },
    ticks: {
      line: {
        strokeWidth: 0,
      },
    },
    legend: {
      text: {
        fontSize: 12,
      },
    },
  },
  // tooltip: {
  //   container: {
  //     background: '#333',
  //   },
  // },
};

export const barConfig = {
  stacked: 'stacked',
  grouped: 'grouped',
  horizontalLayout: 'horizontal',
};

export default theme;
